import { Component, OnInit } from '@angular/core';
import { Searchgeneral } from 'src/app/model/searchgeneral.model';
import { UserService } from 'src/app/services/user/user.service';
import { NgForm } from '@angular/forms';
import { RoleService } from 'src/app/services/role/role.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { Vendorregistration } from 'src/app/model/vendorregistration.model';


@Component({
  selector: 'app-addpurchaselines',
  templateUrl: './addpurchaselines.component.html',
  styleUrls: ['./addpurchaselines.component.css']
})
export class AddpurchaselinesComponent implements OnInit {

  clipExistBool: boolean = false;
  // dropdownSettings = {};
  searchGeneral: Searchgeneral;
  vendreg: Vendorregistration;
  projectid: string;
  countryid: string;
  langid: string;
  projectDetails: any;
  data: any;
  dataL: any;
  dataV: any;
  countryData: any;
  set: string;
  className: string;
  num: number;
  languageData: any;
  showDataBool: boolean = false;
  isListLoading: boolean = false;
  textBoxBool: boolean = true;
  vendDropDown: boolean = true;
  multiple: boolean = false;
  isLoadings: boolean = false;

  constructor(private userService: UserService, private route: ActivatedRoute, private router: Router, private roleservice: RoleService, private toastr: ToastrService) {
    this.projectid = this.route.snapshot.params.projectid;
    this.countryid = this.route.snapshot.params.countryid;
    this.langid = this.route.snapshot.params.langid;
    this.set = this.route.snapshot.params.set;
    this.num = this.route.snapshot.params.num;

  }

  ngOnInit() {
    // this.dropdownSettings = {
    //   singleSelection: true,
    //   idField: 'id',
    //   textField: 'vendorName',
    //   allowSearchFilter: true,
    //   closeDropDownOnSelection:true
    //   };
    this.vendreg = new Vendorregistration();
    if (this.set == "multiple") {
      this.multiple = true;
      //console.log("number" , this.route.snapshot.params.num)
      this.vendreg.unassignsurveylink = this.num;
    }
    this.textBoxBool = true;
    this.searchGeneral = new Searchgeneral();
    // this.vendreg = new Vendorregistration();
    this.getCountryList();
    this.getLanguageList();
    this.getVendorList();

    if (this.projectid != undefined) {
      this.textBoxBool = false;
      this.vendreg.country = this.countryid;
      this.vendreg.language = this.langid;
      this.roleservice.SearchProjectInfoDetails(this.projectid).subscribe(
        (data: any) => {
          this.projectDetails = data;
          if (this.projectDetails.length === 0) {
            this.showDataBool = false;
          }
          else {
            //this.projectid = this.projectDetails[0].projectId;
            this.showDataBool = true;
          }
        }
      )
    }
  }

  getCountryList() {
    debugger;
    this.userService.getCountryList().subscribe(
      (data) => {
        this.countryData = data;
        this.data = this.countryData;
        //console.log("user data" + this.data);
      }
    )
  }

  getLanguageList() {
    debugger;
    this.userService.getLanguageList().subscribe(
      (data) => {
        this.languageData = data;
        this.dataL = this.languageData;
        //console.log("user data" + this.dataL);
      }
    )
  }
  SubmitSearchListForm(form: NgForm) {
    debugger;
    this.isListLoading = true;
    this.roleservice.SearchProjectDetails(this.searchGeneral).subscribe(
      (data: any) => {
        this.isListLoading = false;
        this.projectDetails = data;
        if (this.projectDetails.length === 0) {
          this.showDataBool = false;
          this.toastr.error("No items found", '', { progressBar: true });
        }
        else {
          this.roleservice.GetCountryLanguageList(this.searchGeneral).subscribe(
            (data: any) => {
              console.log(data);
              this.data = data;
            }
          )
          this.projectid = this.projectDetails[0].projectID;
          this.vendreg.country = this.projectDetails[0].countryID;
          this.vendreg.country = "";
          this.vendreg.language = this.projectDetails[0].languageID;
          this.vendreg.language = "";
          this.vendreg.vendorclip = "";
          this.showDataBool = true;
          this.textBoxBool = true;
          this.set = "single";
          this.vendreg.vendorname = "-1";
          this.vendreg.VendCompRedirectURL = "";
          this.vendreg.VendTermRedirectURL = "";
          this.vendreg.VendQFRedirectURL = "";
          this.vendreg.VendQCRRedirectURL = "";
        }
        if (this.projectDetails[0].clintLinkType == "multiple") {
          this.className = "clipButtonMultiple";
          this.multiple = true;
          this.vendreg.vendorname = "-1";
          this.vendreg.VendCompRedirectURL = "";
          this.vendreg.VendTermRedirectURL = "";
          this.vendreg.VendQFRedirectURL = "";
          this.vendreg.VendQCRRedirectURL = "";
          this.set = "multiple";
        }
        else {
          this.className = "clipButton";
          this.multiple = false;
        }
        console.log(this.projectDetails);
      }
    )
  }

  getVendorList() {
    this.roleservice.getVendorDetails().subscribe(
      (data: any) => {
        this.dataV = data;
        console.log(this.dataV)
        if (this.dataV.length === 0) {

        }
        else {

        }
      }
    )
  }

  OnSubmit(form: NgForm) {
    
    debugger;
    
    if (this.set != "multiple") {
      this.isLoadings = true;
      var url = window.location.href;
      url = url.replace("assignvendorclip", "StartSurvey");
      if (this.langid != undefined) {
        form.value.langid = this.langid;
      }
      else {
        //form.value.langid = this.projectDetails[0].languageID;
        form.value.langid = this.vendreg.language;
      }
      if (this.countryid != undefined) {
        form.value.countryid = this.countryid;
      }
      else {
        // form.value.countryid = this.projectDetails[0].countryID;
        form.value.countryid = this.vendreg.country;
      }
      form.value.projectid = this.projectid;
      form.value.url = url;
      console.log(form.value);

      this.userService.checkIfClipExist(form.value).subscribe(
        (data: boolean) => {
          //debugger;
          if (data) {
            this.isLoadings = false;
            this.toastr.error("Provided vendor clip is already assigned for selected project.", '', { progressBar: true });
          }
          else {
            this.userService.addVendorClipData(form.value)
              .subscribe((data: any) => {
                if (data != null && data != undefined) {
                  this.router.navigate(['/viewprojectdetails/' + this.projectid]);
                }
                this.isLoadings = false;
              });


          }
          
        }
      );
    }
    else if (this.set == "multiple") {
      this.isLoadings = true;
      // alert("hello world")
      if ((parseInt(form.value.assignlink) > this.num) || (parseInt(form.value.assignlink) > this.vendreg.unassignsurveylink)) {
        this.toastr.error("Assigned Links cannot be greater than Remaining Links", '', { progressBar: true });
        this.isLoadings = false;
      }
      else {
        var url = window.location.href;
        url = url.replace("assignvendorclip", "StartSurvey");
        if (this.langid != undefined) {
          form.value.langid = this.langid;
        }
        else {
          //form.value.langid = this.projectDetails[0].languageID;
          form.value.langid = this.vendreg.language;
        }
        if (this.countryid != undefined) {
          form.value.countryid = this.countryid;
        }
        else {
          // form.value.countryid = this.projectDetails[0].countryID;
          form.value.countryid = this.vendreg.country;
        }
        form.value.projectid = this.projectid;
        form.value.url = url;
        form.value.vendorclip = form.value.vendorclip ? form.value.vendorclip : this.vendreg.vendorclip;
        console.log(form.value);

        this.userService.checkIfClipExist(form.value).subscribe(
          (data: boolean) => {
            //debugger;
            if (data) {
              this.toastr.error("Provided vendor clip is already assigned for selected project.", '', { progressBar: true });
              this.isLoadings = false;
            }
            else {
              this.userService.addVendorClipDataForMultiple(form.value, this.num)
                .subscribe((data: any) => {
                  if (data != null && data != undefined) {
                    this.router.navigate(['/viewprojectdetails/' + this.projectid]);
                  }
                  this.isLoadings = false;
                });


            }
            
          }
        );
      }
    }
  }

  changeVendor(event) {
    console.log(event.target.value);
    console.log(this.dataV);
    if (event.target.value == 0) {
      this.router.navigate(['/vendorregistration']);
    }
    else {
      for (var i = 0; i < this.dataV.length; i++) {
        if (event.target.value == this.dataV[i].id) {
          this.vendreg.VendCompRedirectURL = this.dataV[i].vendorSC;
          this.vendreg.VendTermRedirectURL = this.dataV[i].vendorST;
          this.vendreg.VendQFRedirectURL = this.dataV[i].vendorSQF;
          this.vendreg.VendQCRRedirectURL = this.dataV[i].vendorSQCR;
        }
      }
    }
  }

  resetForm(form?: NgForm) {
    if (form != null)
      form.reset();

  }

  standardChange(event) {
    this.vendDropDown = true;
  }
  adhocChange(event) {
    this.vendreg.vendorname = "";
    this.vendDropDown = false;
  }

  languageChange(event) {
    debugger;
    if (this.langid == undefined && this.countryid == undefined) {
      this.userService.GetLangList(this.projectid, this.vendreg.country).subscribe(
        (data: any) => {
          console.log(data);
          this.dataL = data;
        }
      )
    }
  }

  languageChangeEvent(event) {
    if (this.projectDetails[0].clintLinkType == "multiple" && this.vendreg.country) {
      this.userService.GetUnassignedLink(this.projectid, this.vendreg.country, this.vendreg.language).subscribe(
        (data: any) => {
          console.log(data);
          if (data) {
            var remainLinKCount = 0;
            // this.vendreg.vendorname = data[0].vid;
            for (var i = 0; i < data.length; i++) {
              remainLinKCount = remainLinKCount + data[i].remainingLinks;
            }
            this.vendreg.unassignsurveylink = remainLinKCount;
            // this.vendreg.VendCompRedirectURL = data[0].vendorSC;
            // this.vendreg.VendTermRedirectURL = data[0].vendorST;
            // this.vendreg.VendQFRedirectURL = data[0].vendorSQF;
            // this.vendreg.VendQCRRedirectURL = data[0].vendorSQCR;
            // this.vendreg.vendorclip = data[0].clip;
          }
        }
      )
    }
  }
}
